import {
    LIVE_DATA
} from 'actions/actionTypes';

const defaultState = []

export default (state = defaultState, action) => {
    switch (action.referenceType) {
      case LIVE_DATA:
        return [
            ...state,
            action
        ]
      default:
        return state;
    }
};

